module.exports = __webpack_public_path__ + "img/discover_white.e6ff6b6d.svg";